const bulkAddEventListener = (object, events, callback) => {
  events.forEach((event) => {
    object.addEventListener(event, callback);
  });
};
const bulkRemoveEventListener = (object, events, callback) => {
  events.forEach((event) => {
    object.removeEventListener(event, callback);
  });
};
class IdleJs {
  constructor(options) {
    this.defaults = {
      idle: 1e4,
      events: ["mousemove", "scroll", "keydown", "mousedown", "touchstart"],
      onIdle: null,
      onActive: null,
      onHide: null,
      onShow: null,
      keepTracking: true,
      startAtIdle: false,
      recurIdleCall: false
    };
    this.throwOnBadKey(Object.keys(options), Object.keys(this.defaults));
    this.settings = Object.assign({}, this.defaults, options);
    this.visibilityEvents = ["visibilitychange", "webkitvisibilitychange", "mozvisibilitychange", "msvisibilitychange"];
    this.clearTimeout = null;
    this.reset();
    this.stopListener = (event) => {
      this.stop();
    };
    this.idlenessEventsHandler = (event) => {
      if (this.idle) {
        this.idle = false;
        this.settings.onActive && this.settings.onActive.call();
      }
      this.resetTimeout(this.settings);
    };
    this.visibilityEventsHandler = (event) => {
      if (document.hidden || document.webkitHidden || document.mozHidden || document.msHidden) {
        if (this.visible) {
          this.visible = false;
          this.settings.onHide && this.settings.onHide.call();
        }
      } else {
        if (!this.visible) {
          this.visible = true;
          this.settings.onShow && this.settings.onShow.call();
        }
      }
    };
  }
  resetTimeout(settings, keepTracking = this.settings.keepTracking) {
    if (this.clearTimeout) {
      this.clearTimeout();
      this.clearTimeout = null;
    }
    if (keepTracking) {
      this.timeout(this.settings);
    }
  }
  timeout(settings) {
    var timer = this.settings.recurIdleCall ? {
      set: setInterval.bind(window),
      clear: clearInterval.bind(window)
    } : {
      set: setTimeout.bind(window),
      clear: clearTimeout.bind(window)
    };
    var id = timer.set(function() {
      this.idle = true;
      this.settings.onIdle && this.settings.onIdle.call();
    }.bind(this), this.settings.idle);
    this.clearTimeout = () => timer.clear(id);
  }
  start() {
    window.addEventListener("idle:stop", this.stopListener);
    this.timeout(this.settings);
    bulkAddEventListener(window, this.settings.events, this.idlenessEventsHandler);
    if (this.settings.onShow || this.settings.onHide) {
      bulkAddEventListener(document, this.visibilityEvents, this.visibilityEventsHandler);
    }
    return this;
  }
  stop() {
    window.removeEventListener("idle:stop", this.stopListener);
    bulkRemoveEventListener(window, this.settings.events, this.idlenessEventsHandler);
    this.resetTimeout(this.settings, false);
    if (this.settings.onShow || this.settings.onHide) {
      bulkRemoveEventListener(document, this.visibilityEvents, this.visibilityEventsHandler);
    }
    return this;
  }
  reset({ idle = this.settings.startAtIdle, visible = !this.settings.startAtIdle } = {}) {
    this.idle = idle;
    this.visible = visible;
    return this;
  }
  throwOnBadKey(keys, goodKeys) {
    keys.forEach(function(key) {
      if (!goodKeys.includes(key)) {
        throw `set: Unknown key ${key}`;
      }
    });
  }
  set(options) {
    this.throwOnBadKey(Object.keys(options), Object.keys(this.defaults));
    this.settings = Object.assign(this.settings, options);
  }
}
export { IdleJs };
